import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var mapleLeaf = /*#__PURE__*/React.createElement("svg", {
  height: "26",
  width: "24",
  viewBox: "0 0 24 26",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.634 26s-.201-5.174-.201-5.69c0-.515.416-.691.905-.579.492.113 5.094 1.095 5.094 1.095s-.35-1.047-.597-1.82c-.242-.774.077-.914.247-1.076l5.143-4.677-.812-.42c-.492-.24-.416-.677-.34-.966l.982-3.308s-2.23.508-2.732.588c-.4.065-.539-.13-.663-.42l-.642-1.61-2.688 3.11c-.506.484-.995.113-.904-.452.086-.513 1.349-6.622 1.349-6.622s-1.394.87-1.856 1.16c-.46.29-.704.241-.95-.225-.241-.46-1.907-3.96-1.968-4.088-.061.127-1.727 3.628-1.968 4.088-.246.466-.489.516-.95.226-.462-.291-1.855-1.161-1.855-1.161S8.49 9.262 8.576 9.775c.09.565-.399.936-.905.452l-2.687-3.11-.642 1.61c-.124.29-.263.485-.662.42C3.178 9.067.947 8.56.947 8.56l.981 3.308c.077.29.154.725-.34.966l-.81.42L5.92 17.93c.169.162.488.302.245 1.075-.245.774-.596 1.82-.596 1.82s4.602-.981 5.095-1.094c.488-.112.904.064.904.58 0 .515-.2 5.689-.2 5.689h1.265Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { mapleLeaf as default };
//# sourceMappingURL=mapleLeaf.js.map
